import { useParams } from 'react-router-dom'
import { CaseEvidence } from '@/features/evidence/CaseEvidence'

/** Compatibility for previously issued source links. New results render inside chat. */
export default function CaseEvidencePage() {
  const { caseId, referenceId } = useParams<{ caseId: string; referenceId: string }>()
  if (!caseId || !referenceId) return null
  return (
    <div className="overflow-auto p-4">
      <CaseEvidence caseId={caseId} referenceId={referenceId} />
    </div>
  )
}
